import { memo } from "react";
import { Button, Header, Icon } from "semantic-ui-react";

// Components
import BroadcastApprovalTopBar from "./BroadcastApprovalTopBar";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

// Styles
import { STYLES } from "./sequence/MeForm";

type HeaderBarProps = {
  title: string;
  onBack: () => void;
  broadcast?: BroadcastPostSerializer;
};

const HeaderBar = (props: HeaderBarProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "20px",
      padding: "0 15px"
    }}
  >
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <Button onClick={props.onBack} style={{ ...STYLES.primaryThemeBtn }}>
        <Icon name="angle left" />
      </Button>

      <Header style={{ color: "var(--primary-theme-color)", margin: 0 }} as="h2">
        {props.title}
      </Header>

      {props.broadcast && (
        <BroadcastApprovalTopBar broadcast={props.broadcast} />
      )}
    </div>
  </div>
);

export default memo(HeaderBar);